import { Action, Reducer } from "redux";
import { SystemApplicationState, SystemApplicationTypes, SystemApplicationActionTypes } from "./systemApplicationTypes";

export const INITIAL_STATE: SystemApplicationState = {
	systemApplication: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const systemApplicationReducer: Reducer<SystemApplicationState> = (
	state: SystemApplicationState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as SystemApplicationActionTypes;
	switch (actionTypes.type) {
		case SystemApplicationTypes.GET_SYSTEM_APPLICATION:
			return {
				...state,
				systemApplication: { ...state.systemApplication, isLoading: true },
			};
		case SystemApplicationTypes.SAVE_SYSTEM_APPLICATION:
			return {
				...state,
				systemApplication: {
					...state.systemApplication,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};

		case SystemApplicationTypes.RESET_REDUCER_SYSTEM_APPLICATION:
			return {
				...state,
				systemApplication: INITIAL_STATE.systemApplication,
			};
		default:
			return state;
	}
};

export default systemApplicationReducer;
